export var ItemsToBeShownInRow;
(function (ItemsToBeShownInRow) {
  ItemsToBeShownInRow[ItemsToBeShownInRow["THREE"] = 3] = "THREE";
  ItemsToBeShownInRow[ItemsToBeShownInRow["FOUR"] = 4] = "FOUR";
})(ItemsToBeShownInRow || (ItemsToBeShownInRow = {}));